import type { Color } from "@scrolly/post-types";

function padZero(str: string) {
  return str.length < 2 ? `0${str}` : str
}

export function colorToHex(color: Color) {
  const { r, g, b } = color

  return `#${padZero(r.toString(16))}${padZero(g.toString(16))}${padZero(
    b.toString(16)
  )}`
}

export function getColorString(color: Color) {
  if (color === undefined) {
    return null
  }

  const { r, g, b, a } = color

  return `rgba(${r}, ${g}, ${b}, ${a})`
}
